// Initialize Tealium
export const initTealium = () => {
  // Set up Tealium data layer
  (window as any).utag_data = {};
  (window as any).utag_cfg_ovrd = (window as any).utag_cfg_ovrd || {};
  (window as any).utag_cfg_ovrd.noview = true;

  // Load Tealium script
  const env = import.meta.env.VITE_APP_ENV === 'PROD' ? 'prod' : 'dev';
  const script = document.createElement('script');
  script.src = `https://tags.tiqcdn.com/utag/amway/internal-tools/${env}/utag.js`;
  script.type = 'text/javascript';
  script.async = true;

  const firstScript = document.getElementsByTagName('script')[0];
  firstScript.parentNode?.insertBefore(script, firstScript);
};
